import { FormSubmissionStatus, FormType } from '@/__generated__/types';
import { CommonTable } from '@/components/commonComponents/commonTable/commonTable';
import { ICommonTableHeadColumn } from '@/components/commonComponents/commonTable/commonTableHead/commonTableHead';
import Scrollbar from '@/components/Scrollbar';
import { Card } from '@mui/material';
import { FormTableRow } from './FormTableRow';

export interface FormSubmissionTableItem {
    id: string;
    formType: FormType;
    formTypeLabel: string;
    restaurantName: string;
    contactName: string;
    mobileNumber: string;
    email: string;
    city: string;
    businessType: string;
    referralSource: string;
    message: string;
    status: FormSubmissionStatus;
    createdAt: number | null;
    createdAtDisplay: string;
    updatedAt: number | null;
    updatedAtDisplay: string;
}

const createFormsTableHead = (): ICommonTableHeadColumn<FormSubmissionTableItem>[] => [
    { property: 'formTypeLabel', label: 'Enquiry Type', align: 'left' },
    { property: 'restaurantName', label: 'Restaurant', align: 'left' },
    { property: 'contactName', label: 'Contact', align: 'left' },
    { property: 'city', label: 'City', align: 'left' },
    { property: 'status', label: 'Status', align: 'center' },
    { property: 'createdAt', label: 'Created At', align: 'left' }
];

interface FormsTableProps {
    submissionList: FormSubmissionTableItem[];
    isLoading: boolean;
    onStatusUpdated: () => void;
    customerHeader?: JSX.Element;
}

export const FormsTable = ({ submissionList, isLoading, onStatusUpdated, customerHeader }: FormsTableProps): JSX.Element => {
    return (
        <Card>
            <Scrollbar>
                <CommonTable
                    columnList={createFormsTableHead()}
                    dataList={submissionList}
                    isLoading={isLoading}
                    tableRowKey="id"
                    RowBodyComponent={FormTableRow}
                    rowBodyProps={{
                        onStatusUpdated
                    }}
                    customerHeader={customerHeader}
                    rowsPerPageOptions={[10, 25, 50]}
                />
            </Scrollbar>
        </Card>
    );
};
